import { Button } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Styles } from '../styles';

export const ReviewsShowMoreButton: React.FC<{
  fetchNext: () => void;
}> = ({ fetchNext }) => {
  const { t } = useTranslation();
  return (
    <Button
      data-qa="review-show-more_mf-pdp"
      as="button"
      className={Styles.showMoreButton}
      onClick={fetchNext}
      size="l"
      kind="regular"
      variant="secondary"
    >
      {t('reviews.ui.show-more')}
    </Button>
  );
};
